import { atom } from 'recoil';

export const licenseAtom = atom({
  key: 'licenseAtom',
  default: '',
});